<template>
  <div class="headBox">
    <div class="contentBox contentWidth">
      <!-- 顶部 S -->
      <div class="informationBox">
        <div class="time">
          <h3 class="bigTitle">
            <img src="@/assets/images/home/logo.png" alt="" class="gh" />
          </h3>
        </div>
        <div class="settingsBox">
          <div class="search-container">
            <a-input-search
              placeholder="请输入您要搜索的内容"
              v-model="keywords"
              @search="handleSearch"
            >
              <a-button slot="enterButton" type="primary" class="search-btn">
                <a-icon type="search" />搜索
              </a-button>
            </a-input-search>
          </div>
        </div>
      </div>
    </div>
    <!-- 导航 S   @click="changeMenu(item, index)"-->
    <div class="menu">
      <div class="item">
        <img
          src="@/assets/images/home/home.png"
          alt=""
          @click="$router.push('/home')"
        />
      </div>
      <div
        class="item"
        v-for="(item, index) in menuList"
        :key="item.name"
        @click="changeMenu(item, index)"
      >
        <div class="item-content">
          <p class="itemName">{{ item.name }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Search from "@/components/search/search.vue";
import { NavList } from "@/utils/contans.js";
import { getCurrentDateTime } from "@/plugins/select-option/util";

export default {
  name: "HeadPage",
  components: { Search, NavList },
  props: {
    // activeIndex: {
    //   type: [String, Number],
    //   default: 0,
    // },
  },
  data() {
    return {
      keywords: "",
      iskeywords: false,
      dateInfo: getCurrentDateTime(),
      menuList: NavList,
      isNavigating: false, // 防止重复导航
    };
  },
  computed: {
    activeCode() {
      return this.$route.query.code || "";
    },
  },
  methods: {
    // getActiveCode(item) {
    //   return this.activeCode === item.code
    //   // if(item.code) {
    //   //   return this.activeCode === item.code
    //   // }
    //   // return item.path == '/home'
    //   // if(item.path == this.$route.path) return item.path == '/home'
    // },
    inputText(e) {
      if (e.length) {
        this.iskeywords = true;
      } else {
        this.iskeywords = false;
      }
    },
    handleSearch() {
      // 防止重复导航
      if (this.isNavigating) {
        return;
      }
      // 如果已经在搜索页面且关键词相同，则不导航
      if (
        this.$route.path === "/search" &&
        this.$route.query.keywords === this.keywords
      ) {
        return;
      }

      this.isNavigating = true;
      this.$router
        .push({
          path: "/search",
          query: { keywords: this.keywords },
        })
        .catch((err) => {
          // 忽略导航重复的错误
          if (err.name !== "NavigationDuplicated") {
            console.error("导航错误:", err);
          }
        })
        .finally(() => {
          // 导航完成后重置标志
          this.$nextTick(() => {
            this.isNavigating = false;
          });
        });
    },
    changeMenu(item) {
      if (this.activeCode === item.code && item.path === this.$route.path)
        return;
      if (!item.code) return this.$router.push("/list");
      const url = this.$router.resolve({
        path: item.path,
        query: { code: item.code, id: item.id },
      }).href;
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.headBox {
  background: url("@/assets/images/home/top-bg.jpg") no-repeat;
  background-size: 100%;
  position: relative;
  width: 100%;
  min-height: 315px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .contentWidth{
    width: 14rem !important;
  }
  .contentBox {
    // width: 80vw;
    flex-shrink: 0;
    // background: #bfa;
    margin-top: 30px;

    .informationBox {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 18px;
      color: #666;

      .time {
        display: flex;
        align-items: center;

        .weekDay {
          padding-left: 5px;
        }

        .timePeriod {
          padding-left: 10px;
        }
      }

      .settingsBox {
        display: flex;
        align-items: center;

        .home {
          position: relative;
          padding-right: 10px;
          cursor: pointer;

          &::after {
            width: 1px;
            height: 20px;
            position: absolute;
            right: 0px;
            top: 0px;
            content: "";
            background: #666;
          }
        }

        .home:hover {
          color: #d61618;
        }

        .collection {
          padding-left: 10px;
          cursor: pointer;
        }

        .collection:hover {
          color: #d61618;
        }
      }
    }
  }
}

.search-container {
  margin-left: 10px;
  width: auto;
  /* 由 input 控制宽度 */
  font-size: 20px;
  color: #222;
  position: relative;
  ::v-deep .ant-input {
    outline: none;
    box-shadow: none;
    border: none;
    width: 300px;
    height: 42px;
    font-size: 18px;
  }
  ::v-deep .ant-input-suffix {
    font-size: 24px;
  }
  .search-btn {
    height: 42px;
    border-radius: 6px;
    background: #0f6fc5;
  }
}

.search-container input {
  width: 300px;
  padding: 10px;
  // border-radius: 10px;
  outline: none;
  border: none;
  background: rgba(254, 243, 241, 0.85);
  // background: linear-gradient(180deg,
  //     rgba(254, 243, 241, 0.85) 0%,
  //     rgba(204, 227, 255, 1) 100%);
  box-sizing: border-box;
  transition: width 0.3s ease;
  /* 平滑动画 */
}

/* 输入时变长 */
.search-container input.expanded {
  width: 300px;
}

/* 左侧图标+文字 */
.search-container .icon-text {
  width: 300px;
  position: absolute;
  left: 5px;
  top: 15px;
  // transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  pointer-events: none;
  color: #999;
}

.search-container .icon-text img {
  position: absolute;
  right: 5px;
  width: 20px;
  margin-right: 10px;
}

.bigTitle {
  position: relative;
  margin-top: 40px;
  display: flex;
  align-content: center;
  color: #d61618;

  .gh {
    // width: 90px;
    height: 130px;
    flex-shrink: 0;
  }
}

.menu {
  width: 100%;
  background-color: #015293;
  padding: 0 calc((100% - 13rem) / 2);
  position: relative;
  margin-top: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 24px;
  height: 74px;
  .item {
    cursor: pointer;
    text-align: center;
    display: flex;
    justify-content: center;
    img {
      width: 79px !important;
      height: 78px;
    }

    .item-content {
      align-items: center;
      display: flex;
      justify-content: center;
      height: 74px;
      position: relative;
      .itemName {
        padding-left: 10px;
        font-size: 24px;
      }
      &::after {
        position: absolute;
        content: "";
        bottom: 0;
        left: 0;
        height: 4px;
        width: 100%;
        background: transparent;
        border-radius: 4px;
      }
      &.active,
      &:hover {
        &::after {
          background: #fff;
        }
      }
    }
  }
}
</style>
